import {
    QueryCategoryInfo,
    QueryCategoryPage,
    QueryDesignerPage,
    QueryListPage,
    SaveCategory,
    UpdateCategory,
    QueryComponentCategoryList,
    QueryDefinitionPage,
    DeleteCategory,
    UpdateSortCategory,
    SaveDefinition,
    UpdateDefinition,
    PublishDefinition,
    UnPublishDefinition,
    StartInstance,
    ApplyDevCustomer,
    QueryFlowalbeInfo,
    DeleteDefinition,
    QueryAgentFlowable,
    ClearInstance,
    QueryDoneFlowable,
    QueryFlowableState,
    ApprovalPass,
    ApprovalQuit,
    ApprovalReject,
    QueryTaskAll,
    QueryHisTask,
    QueryLaunchFlowable,
    ApplyDelayCustomer,
    CopyDefinition,
    ApplyFeeMonthOut,
    AdditionalFee,
    ApplyReimburs,
    QueryTaskList,
    UpdateActiveDefine,
    UpdateUnActiveDefine
} from '../../request/process';
import { flateTree } from '@/utils/common';
export default {
    namespace: true,
    state: {
        categoryList: [],
        cateList: [],
        flowableStatus: [],
        flowableState: {},
        flowableCount: 0
    },
    mutations: {
        SET_CATEGORY_LIST(state, categoryList) {
            state.categoryList = categoryList;
        },
        SET_CATEGORY_FLAT_MENU(state, cateList) {
            state.cateList = cateList;
        },
        SET_FLOWABLE_STATE(state, flowableState) {
            state.flowableState = flowableState;
        },
        SET_FLOWABLE_STATUS(state, flowableStatus) {
            state.flowableStatus = flowableStatus;
        },
        SET_AGENT_FLOWABLE_COUNT(state, flowableCount) {
            state.flowableCount = flowableCount;
        }
    },
    actions: {
        UPDATE_CATEGORY_FLAT_MENU: async ({ commit }, payload) => {
            commit('SET_CATEGORY_FLAT_MENU', payload.cateList);
        },
        QUERY_DESIGNER_PAGE: async ({}, payload) => {
            let res = await QueryDesignerPage(payload);
            return res;
        },

        QUERY_LIST_PAGE: async ({}, payload) => {
            let res = await QueryListPage(payload);
            return res;
        },
        QUERY_CATEGORY_PAGE: async ({ commit }, payload) => {
            let res = await QueryCategoryPage(payload);
            commit('SET_CATEGORY_LIST', res.data ?? []);
            commit('SET_CATEGORY_FLAT_MENU', flateTree(res.data ?? [], 'children'));
            return res;
        },
        QUERY_CATEGORY_INFO: async ({}, payload) => {
            let res = await QueryCategoryInfo(payload);
            return res;
        },
        SAVE_CATEGORY: async ({}, payload) => {
            let res = await SaveCategory(payload);
            return res;
        },
        UPDATE_PROCESS_CATEGORY: async ({}, payload) => {
            let res = await UpdateCategory(payload);
            return res;
        },
        UPDATE_SORT_CATEGORY: async ({}, payload) => {
            let res = await UpdateSortCategory(payload);
            return res;
        },
        DELETE_FLOWABLE_CATEGORY: async ({}, payload) => {
            let res = await DeleteCategory(payload);
            return res;
        },

        QUERY_DEFINITION_PAGE: async ({}, payload) => {
            let res = await QueryDefinitionPage(payload);
            return res;
        },

        SAVE_DEFINITION: async ({}, payload) => {
            let res = await SaveDefinition(payload);
            return res;
        },

        UPDATE_DEFINITION: async ({}, payload) => {
            let res = await UpdateDefinition(payload);
            return res;
        },
        COPY_DEFINITION: async ({}, payload) => {
            let res = await CopyDefinition(payload);
            return res;
        },
        DELETE_DEFINITION: async ({}, payload) => {
            let res = await DeleteDefinition(payload);
            return res;
        },
        PUBLISH_DEFINITION: async ({ commit }, payload) => {
            let res = await PublishDefinition(payload);
            return res;
        },

        UN_PUBLISH_DEFINITION: async ({}, payload) => {
            let res = await UnPublishDefinition(payload);
            return res;
        },

        UPDATE_ACTIVE_DEFINE: async ({}, payload) => {
            let res = await UpdateActiveDefine(payload);
            return res;
        },
        UPDATE_UNACTIVE_DEFINE: async ({}, payload) => {
            let res = await UpdateUnActiveDefine(payload);
            return res;
        },

        APPLY_DEV_CUSTOMER: async ({}, payload) => {
            let res = await ApplyDevCustomer(payload);
            return res;
        },

        START_INSTANCE: async ({}, payload) => {
            let res = await StartInstance(payload);
            return res;
        },

        CLEAR_INSTANCE: async ({}, payload) => {
            let res = await ClearInstance(payload);
            return res;
        },

        QUERY_FLOWABLE_INFO: async ({}, payload) => {
            let res = await QueryFlowalbeInfo(payload);
            return res;
        },

        QUERY_AGENT_FLOWABLE: async ({ commit }, payload) => {
            let res = await QueryAgentFlowable(payload);
            if (res?.code == 200) {
                commit('SET_AGENT_FLOWABLE_COUNT', res.data.count);
            } else {
                commit('SET_AGENT_FLOWABLE_COUNT', 0);
            }
            return res;
        },

        QUERY_DONE_FLOWABLE: async ({ commit }, payload) => {
            let res = await QueryDoneFlowable(payload);
            return res;
        },

        QUERY_FLOWABLE_STATE: async ({ commit }, payload) => {
            let res = await QueryFlowableState();
            if (res?.code == 200) {
                let list = [];
                for (let k in res.data) {
                    list.push({
                        value: k,
                        label: res.data[k]
                    });
                }
                commit('SET_FLOWABLE_STATE', res.data ?? {});
                commit('SET_FLOWABLE_STATUS', list ?? []);
            } else {
                commit('SET_FLOWABLE_STATE', {});
                commit('SET_FLOWABLE_STATUS', []);
            }
            return res;
        },

        QUERY_LAUNCH_FLOWABLE: async ({}, payload) => {
            let res = await QueryLaunchFlowable(payload);
            return res;
        },

        //审批
        APPROVAL_PASS: async ({}, payload) => {
            let res = await ApprovalPass(payload);
            return res;
        },

        APPROVAL_QUIT: async ({}, payload) => {
            let res = await ApprovalQuit(payload);
            return res;
        },

        APPROVAL_REJECT: async ({}, payload) => {
            let res = await ApprovalReject(payload);
            return res;
        },

        QUERY_TASK_ALL: async ({ commit }, payload) => {
            let res = await QueryTaskAll(payload);
            return res;
        },
        QUERY_HIS_TASK: async ({}, payload) => {
            let res = await QueryHisTask(payload);
            return res;
        },

        APPLY_DELAY_CUSTOMER: async ({}, payload) => {
            let res = await ApplyDelayCustomer(payload);
            return res;
        },

        APPLY_FEE_MONTH_OUT: async ({}, payload) => {
            let res = await ApplyFeeMonthOut(payload);
            return res;
        },

        ADDITIONAL_FEE: async ({}, payload) => {
            let res = await AdditionalFee(payload);
            return res;
        },
        APPLY_REIMBURS: async ({}, payload) => {
            let res = await ApplyReimburs(payload);
            return res;
        },

        QUERY_TASK_LIST: async ({}, payload) => {
            let res = await QueryTaskList(payload);
            return res;
        }
    }
};
